import {
  Directive,
  Host,
  Self,
  Optional,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { FormFieldControl } from '../../form-field-control';
import { Subject } from 'rxjs';
import { RadioGroupComponent } from './radio-group.component';

@Directive({
  selector:
    'ot-radio-group[formControlName], ot-radio-group[formControl], ot-radio-group[ngModel]',
  providers: [
    {
      provide: FormFieldControl,
      useExisting: RadioGroupControlDirective,
      multi: false,
    },
  ],
})
export class RadioGroupControlDirective
  implements FormFieldControl<any>, OnInit, OnDestroy
{
  stateChanges = new Subject<void>();
  id: string;
  placeholder: string;
  ngControl: NgControl | null;
  focused: boolean;
  empty: boolean;
  required: boolean;
  disabled: boolean;
  errorState: boolean;
  value: any;

  constructor(
    @Host() private host: RadioGroupComponent,
    @Optional() @Self() control: NgControl
  ) {
    this.ngControl = control;
  }

  ngOnInit() {
    this.id = this.host.id;
    this.placeholder = this.host.placeholder;
    this.required = this.host.required;
    this.disabled = this.host.disabled;
    this.value = this.host.value;
    this.focused = this.host.focused;
    this.empty = this.host.empty;

    this.host.stateChanges.subscribe(() => {
      this.value = this.host.value;
      this.required = this.host.required;
      this.disabled = this.host.disabled;
      this.focused = this.host.focused;
      this.empty = this.host.empty;
      this.stateChanges.next();
    });
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }

  setDescribedByIds(ids: string[]): void {
    this.host.setDescribedByIds(ids);
  }

  focus(): void {
    this.host.focus();
  }
}
